/**
 * Per-competition rules — opt-in registration.
 *
 * Rule files under `./rules/` exist as inert data: importing them has zero
 * side effects on the app. A rule only becomes active once it is referenced
 * in the `ENABLED_RULES` array below.
 *
 * To activate a rule:
 *   1. Make sure the rule file exists under `./rules/` (one per competition).
 *      If not, create it - see `./rules/championsLeague.ts` for the shape.
 *   2. Import it here and append to `ENABLED_RULES`.
 *   3. Deploy.
 *
 * To deactivate a rule: remove its entry below and deploy. The rule file can
 * stay in the codebase - without an entry here it is invisible to
 * `getCompetitionRule(...)`.
 *
 * There is intentionally no env-var override, kill-switch field, or backend
 * fetch: this file IS the configuration. The list of activated rules is part
 * of the codebase, version-controlled, and identical across every environment
 * built from the same commit.
 */

import championsLeague from './rules/championsLeague';
import europaLeague from './rules/europaLeague';
import nationsLeague from './rules/nationsLeague';
import worldCup2026 from './rules/worldCup2026';
import type { CompetitionRule } from './types';

/** Rules currently activated on the platform - at most one per competition. */
export const ENABLED_RULES: CompetitionRule[] = [worldCup2026, championsLeague, europaLeague, nationsLeague];
